function _regenerator() { var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import loadEnv from '@formative/browser-startup/loadEnv';
import { authenticationConstants } from '@formative/lib/constants/authenticationConstants';
import { FontTypes } from '@formative/react-styles/FontTypes';
import loadFonts from '@formative/react-styles/loadFonts';
import domready from 'domready';
var browserMain = function () {
  var _ref = _asyncToGenerator(_regenerator().m(function _callee2() {
    var hideReactRootStyle, cmsHelpersForAnonymousUser, _yield$import, publish, reactPromise, reactDomPromise, eventBusPromise, clientSideAppPromise, _yield$reactPromise, React, _yield$reactDomPromis, hydrateRoot, createRoot, _yield$eventBusPromis, _publish, _yield$import2, getAuthorizationLoginToken, _yield$clientSideAppP, ClientSideApp;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          hideReactRootStyle = document.createElement('style');
          hideReactRootStyle.innerHTML = '#react-root { visibility: hidden; }';
          document.head.appendChild(hideReactRootStyle);
          loadEnv();
          loadFonts([FontTypes.openSans, FontTypes.materialIconsOutlined, FontTypes.nativeEmoji]);
          _context2.n = 1;
          return Promise.all([import('@formative/browser-startup/logging').then(function (_ref2) {
            var init = _ref2.init;
            return init();
          }), import('@formative/browser-startup/browserOtel').then(function (_ref3) {
            var init = _ref3.init;
            return init();
          }), import('@formative/browser-startup/vector').then(function (_ref4) {
            var init = _ref4.init;
            return init();
          }), import('@formative/browser-cms-helpers/postMessage').then(function (_ref5) {
            var init = _ref5.init;
            return init();
          }), import('@formative/browser-cms-helpers/handlePostMessage').then(function (_ref6) {
            var handlePostMessage = _ref6["default"];
            window.addEventListener('message', function (event) {
              if (event.isTrusted && typeof event.data === 'string' && /^\{.*\}$/.test(event.data)) {
                handlePostMessage(event);
              }
            });
          })]);
        case 1:
          cmsHelpersForAnonymousUser = window.location.pathname === '/_cms' && !localStorage.getItem(authenticationConstants.loginToken);
          if (!cmsHelpersForAnonymousUser) {
            _context2.n = 3;
            break;
          }
          _context2.n = 2;
          return import('@formative/lib/eventBus');
        case 2:
          _yield$import = _context2.v;
          publish = _yield$import.publish;
          publish('user', 'ready', null);
          _context2.n = 9;
          break;
        case 3:
          reactPromise = import('react');
          reactDomPromise = import('react-dom/client');
          eventBusPromise = import('@formative/lib/eventBus');
          clientSideAppPromise = import("./ClientSideApp.js");
          _context2.n = 4;
          return reactPromise;
        case 4:
          _yield$reactPromise = _context2.v;
          React = _yield$reactPromise["default"];
          _context2.n = 5;
          return reactDomPromise;
        case 5:
          _yield$reactDomPromis = _context2.v;
          hydrateRoot = _yield$reactDomPromis.hydrateRoot;
          createRoot = _yield$reactDomPromis.createRoot;
          _context2.n = 6;
          return eventBusPromise;
        case 6:
          _yield$eventBusPromis = _context2.v;
          _publish = _yield$eventBusPromis.publish;
          _context2.n = 7;
          return import('@formative/browser-session/getAuthorizationLoginToken');
        case 7:
          _yield$import2 = _context2.v;
          getAuthorizationLoginToken = _yield$import2["default"];
          _context2.n = 8;
          return clientSideAppPromise;
        case 8:
          _yield$clientSideAppP = _context2.v;
          ClientSideApp = _yield$clientSideAppP["default"];
          domready(_asyncToGenerator(_regenerator().m(function _callee() {
            var prerenderedRoot, createRootElement, root;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  prerenderedRoot = document.getElementById('react-root');
                  if (prerenderedRoot && !getAuthorizationLoginToken()) {
                    hydrateRoot(prerenderedRoot, React.createElement(ClientSideApp));
                    setTimeout(function () {
                      return _publish('app', 'startup');
                    }, 0);
                  } else {
                    createRootElement = function createRootElement() {
                      var root = document.createElement('div');
                      root.id = 'react-root';
                      document.body.appendChild(root);
                      return root;
                    };
                    root = createRoot(prerenderedRoot || createRootElement());
                    root.render(React.createElement(ClientSideApp));
                    setTimeout(function () {
                      return _publish('app', 'startup');
                    }, 0);
                  }
                  hideReactRootStyle.remove();
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          })));
        case 9:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return function browserMain() {
    return _ref.apply(this, arguments);
  };
}();
Promise.resolve().then(browserMain)["catch"](function (err) {
  var style = document.createElement('style');
  style.textContent = "\n    .app-startup-error {\n      position: fixed;\n      top: 20px;\n      left: 20px;\n      right: 20px;\n      background: #fff;\n      border: 1px solid #ccc;\n      padding: 40px;\n      z-index: 9999;\n      overflow: auto;\n      font-family: sans-serif;\n      box-shadow: 0 0 10px rgba(0,0,0,0.5);\n    }\n    .app-startup-error-close {\n      position: absolute;\n      right: 40px;\n      top: 40px;\n      border: none;\n      background: none;\n      font-size: 40px;\n      cursor: pointer;\n      line-height: 1;\n      padding: 0;\n    }\n  ";
  document.head.appendChild(style);
  var errorDiv = document.createElement('div');
  errorDiv.className = 'app-startup-error';
  var closeButton = document.createElement('button');
  closeButton.className = 'app-startup-error-close';
  closeButton.innerHTML = '×';
  closeButton.setAttribute('aria-label', 'Close');
  closeButton.onclick = function () {
    errorDiv.remove();
    style.remove();
  };
  var h1 = document.createElement('h1');
  h1.textContent = 'Application Startup Error';
  var timeCode = document.createElement('code');
  timeCode.textContent = new Date().toISOString();
  var userAgentP = document.createElement('p');
  userAgentP.textContent = "User Agent: ".concat(navigator.userAgent);
  var message = err instanceof Error ? err.message : String(err);
  var errMessageP = document.createElement('p');
  errMessageP.textContent = "Error: ".concat(message);
  var stackTraceP = document.createElement('p');
  stackTraceP.textContent = 'Stack Trace:';
  errorDiv.append(closeButton, h1, timeCode, userAgentP, errMessageP, stackTraceP);
  var stack = err instanceof Error && err.stack;
  if (stack) {
    var stackTracePre = document.createElement('pre');
    stackTracePre.textContent = stack;
    errorDiv.append(stackTracePre);
  }
  document.body.appendChild(errorDiv);
});